<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "@/assets/iconfont/iconfont.css";
import "@/assets/iconfont2/iconfont.css";
export default {
  name: "App",
  components: {},
};
</script>
